<template>
  <div>
    <breadcrumb :breadcrumbs="breadcrumbs" />
    <header-banner title="会社案内" />
    <table class="common-table">
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <th>{{ item.th }}</th>
          <td>{{ item.td }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import HeaderBanner from '@/components/modules/HeaderBanner'
import Breadcrumb from '@/components/modules/Breadcrumb'
export default {
  components: {
    HeaderBanner,
    Breadcrumb,
  },
  title: '会社案内｜B-Call（ビーコール）',
  data() {
    return {
      items: [
        { th: '店　名', td: 'B-CALL（ビーコール）' },
        { th: '会社名', td: '株式会社ビーアッサ（B-ASSA Co.,Ltd．）' },
        {
          th: '本社：所在地',
          td: '〒922-0101 石川県加賀市山中温泉中田町ハ-101',
        },
        {
          th: '営業所：所在地',
          td: '〒921-8811 石川県野々市市高橋町10-18',
        },
        { th: 'TEL', td: '076-294-4440' },
        { th: 'FAX', td: '076-294-4432' },
        { th: '取引銀行', td: '【北國銀行】野々市支店' },
        { th: '事業内容', td: '業務用呼び出しシステム販売、広告宣伝業' },
        { th: '会社営業時間', td: '10:00 ～ 19:00' },
        { th: '受注業務', td: '年中無休、24 時間受付' },
        { th: '発送業務', td: '月曜日～金曜日（休業日を除く）' },
        {
          th: '休業日',
          td: '土日祝日、会社指定の休日（GW、お盆、年末年始、他）',
        },
      ],
    }
  },
  computed: {
    breadcrumbs: function() {
      return {
        data: [
          {
            name: '呼び出しベルのB-Call',
            path: 'https://b-call.jp/',
          },
          {
            name: '会社案内',
            path: 'https://b-call.jp/company',
          },
        ],
      }
    },
  },
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/pages/Company.vue